import config from '@/core/config/config';
import { REFERRAL_CREDITS } from '@/graphql/queries';
import { customFetcher, getGqlString } from '@/utils/customFetcher';
import { swrConfig } from '@/utils/swrConfig';
import { useCookies } from 'react-cookie';
import useSWRImmutable from 'swr/immutable';

const currentUserFetcher = async (gqlDocument: any) => {
  return customFetcher(config.APPS_SERVER, {
    query: getGqlString(gqlDocument),
  });
};

export const useReferralCredits = (userId: string | null) => {
  const [cookies] = useCookies();
  const userIsNotLoggedIn = !cookies.prenuvoLOGIN;

  const { data, error, isLoading } = useSWRImmutable(
    userIsNotLoggedIn ? null : [REFERRAL_CREDITS],
    ([query]) => currentUserFetcher(query),
    swrConfig,
  );

  return { data: data?.data?.referralCredit, error, isLoading };
};
